import { messageGuard, messageResolver } from '@@/i18n/utils'
import { useI18n as _useI18n, type UseI18nOptions } from '#i18n'

export const useLocalI18n = (options: UseI18nOptions = {}) => {
  const { $i18n } = useNuxtApp()
  const instance = getCurrentInstance()
  const i18n = _useI18n({
    useScope: 'global',
    ...options,
    fallbackRoot: !messageGuard($i18n),
    messageResolver: messageResolver($i18n, instance),
  })
  return i18n
}
